<template>
  <div class="chargeMaintenance">
    <my-head :title="title"/>

    <div class="auto-width chargeMaintenance-box">
      <mu-text-field v-model="form.vin" v-show="isNullTask" @blur="" placeholder="VIN" ref="vin" class='input auto-width' @keyup.enter.native="getData()"><i class="iconfont icon-saomiao" @click="scan('vin')"></i></mu-text-field>

      <!-- <mu-card class="my-null" v-show="isNullTask">当前无任务</mu-card> -->

      <mu-card class="my-card" v-show="isShowCard">
        <mu-row align-items="center">
          <mu-col span="8"><div class="grid-cell">单号：{{info.code}}</div></mu-col>
          <mu-col span="4"><div class="grid-cell">{{info.status}}</div></mu-col>
          <mu-col span="12"><div class="grid-cell">VIN：{{info.vin}}</div></mu-col>
          <mu-col span="6"><div class="grid-cell">车型：{{info.carType}}</div></mu-col>
          <mu-col span="6"><div class="grid-cell">颜色：{{info.color}}</div></mu-col>
          <mu-col span="12"><div class="grid-cell">库位：{{info.location}}</div></mu-col>
          <mu-col span="12"><div class="grid-cell">领取任务日期：{{info.startDate}}</div></mu-col>
          <mu-col span="12"><div class="grid-cell">计划完成日期：{{info.planDate}}</div></mu-col>
          <mu-col span="12"><div class="grid-cell">备注：{{info.remarks}}</div></mu-col>
          <mu-col span="3"><div class="grid-cell">充前电压：</div></mu-col>
          <mu-col span="9">
            <div class="grid-cell flex">
              <mu-text-field v-model="info.beforeLowPower" :disabled="true" placeholder="LV" ref="vin" class='auto-width-s ft'></mu-text-field>
              <mu-text-field v-model="info.beforeHighPower" :disabled="true" placeholder="HV" ref="vin" class='auto-width-s ft'></mu-text-field>
            </div>
          </mu-col>
          <mu-col span="3"><div class="grid-cell">充后电压：</div></mu-col>
          <mu-col span="9">
            <div class="grid-cell flex">
              <mu-text-field v-model="info.afterLowPower" placeholder="LV" ref="vin" class='auto-width-s ft' @focus="openSelector('lv', info, 'afterLowPower')"></mu-text-field>
              <mu-text-field v-model="info.afterHighPower" placeholder="HV" ref="vin" class='auto-width-s ft' @focus="openSelector('hv', info, 'afterHighPower')"></mu-text-field>
            </div>
          </mu-col>
        </mu-row>
      </mu-card>
    </div>

    <div class="maintenance-btn auto-width fixed">
      <mu-button full-width color="primary" @click="goBackTask">回退任务</mu-button>
      <mu-button full-width color="primary" v-show="isShowDcd" @click="receive('wait')">领取待充电任务</mu-button>
      <mu-button full-width color="primary" v-show="isShowCdz" @click="receive('working')">领取充电中任务</mu-button>
      <mu-button color="primary" @click="openSheet('sure')" v-show="is_MENU_YZCDQ">移至充电区</mu-button>
      <mu-button color="primary" @click="saveCharge('sure')" v-show="is_MENU_CDQR">充电确认</mu-button>
      <mu-button color="primary" @click="openSheet('done')" v-show="is_MENU_YZCFQ">移至存放区</mu-button>
      <mu-button color="primary" @click="saveCharge('done')" v-show="is_MENU_CDWC">充电完成</mu-button>
    </div>

    <mu-bottom-sheet :open.sync="openBottomSheet" style="height: 100vh;">
      <mu-sub-header style="height: 8vh;">选择库区</mu-sub-header>
      <mu-list  style="height: 90vh;">
        <mu-list-item button v-for="item in area" :key="item.id" @click="selectAreas(item.id)">
          <mu-list-item-title>库区 - {{item.name}}</mu-list-item-title>
        </mu-list-item>
      </mu-list>
    </mu-bottom-sheet>

    <mu-bottom-sheet :open.sync="selector">
      <div class="bottom-sheet-mine">
        <div @click="cancelValue">取消</div>
        <div @click="sureValue">确认</div>
      </div>
      <mu-slide-picker :slots="slots" :visible-item-count="5" @change="selectValueChange" :values="val"></mu-slide-picker>
    </mu-bottom-sheet>

    <!--图片全屏预览-->
    <!-- <mu-dialog width="360" transition="slide-bottom" fullscreen :open.sync="openFullscreen">
      <mu-appbar color="" title="">
      <mu-button slot="right" flat  @click="closeFullscreenDialog">关闭</mu-button>
      </mu-appbar>
      <div id='ylbox'>
          <mu-carousel :cycle="false">
              <mu-carousel-item>
                  <img :src="bigImg">
              </mu-carousel-item>
          </mu-carousel>
      </div>
    </mu-dialog>

    <div class="photos">
      <div class="imgs" v-for="(item, index) in src" :key="index" @touchstart.stop="touchin(index)" @touchend.stop="cleartime()" @click.stop="openFullscreenDialog(index)">
          <img :src="item" >
      </div>
      <i class="iconfont icon-icon25201" @click="paizhao"></i>
    </div>

    <mu-dialog width="320" max-width="60%" :open.sync="openAlert">
      确认删除图片?
      <mu-button slot="actions" flat color="primary" @click="closeAlertDialog('n')">取消</mu-button>
      <mu-button slot="actions" flat color="primary" @click="closeAlertDialog('y')">删除</mu-button>
    </mu-dialog>

    <mu-data-table id="mytable" :loading="tableLoading" :columns="columns" :sort.sync="sort" @sort-change="handleSortChange" :data="list.slice(0, 6)">
      <template slot-scope="scope">
        <td>{{scope.row.name}}</td>
        <td>{{scope.row.unit}}</td>
        <td>{{scope.row.quantity}}</td>
        <td><mu-text-field v-model="scope.row.chargeMaintenanceQuantity"></mu-text-field></td>
      </template>
    </mu-data-table>

    <div class="chargeMaintenance-btns auto-width">
      <mu-button color="info">点检记录</mu-button>
      <mu-button color="info">提交</mu-button>
    </div> -->

    <scanning v-if="isScanning" :mark="scanMark" v-on:childByValue="childByValue" v-on:closeing="closeing"/>
  </div>
</template>

<script>
import myHead from '@/components/header'
import api from '@/common/api'
import scanning from '@/components/scanning'
let lv = {}
for (let i = 0; i <= 100; i += 10) {
  lv[i] = 0
}
let hv = {}
for (let i = 0; i <= 50; i += 1) {
  hv[i] = 0
}
let ty = {}
for (let i = 0; i <= 3.9; i += 0.05) {
  ty[i.toFixed(2).toString()] = 0
}
export default {
  name: 'pickcar',
  components: {
    myHead, scanning
  },
  data () {
    return {
      slots: [{
        width: '100%',
        textAlign: 'center',
        values: Object.keys(lv)
      }],
      val: ['80', '0'],
      lvSlots: [
        {
          width: '100%',
          textAlign: 'center',
          values: Object.keys(lv)
        }
      ],
      lv: ['80', '0'],
      hvSlots: [
        {
          width: '100%',
          textAlign: 'center',
          values: Object.keys(hv)
        }
      ],
      hv: ['25', '0'],
      tySlots: [
        {
          width: '100%',
          textAlign: 'center',
          values: Object.keys(ty)
        }
      ],
      ty: ['3.50', '0'],
      selector: false,
      title: '充电保养',
      scanMark: '',
      area: [], // 库区
      selectArea: '',
      tableLoading: false,
      isShowCard: false, // 展示卡片
      isScanning: false,
      isNullTask: true,
      isShowDcd: true, // 领取待充电任务
      isShowCdz: true, // 领取充电中任务
      isShowCdq: false, // 移至充电区
      isShowCdqr: false, // 充电确认
      isShowCfq: false, // 移至存放区
      isShowCdwc: false, // 充电完成
      is_MENU_CDQR: false, // 充电确认
      is_MENU_CDWC: false, // 充电完成
      is_MENU_YZCDQ: false, // 移至充电区
      is_MENU_YZCFQ: false, // 移至存放区

      openFullscreen: false,
      deleteIndex: null, // 删除第几张
      openAlert: false, // 删除图片层
      src: [], // 拍照的图片
      files: [], // 图片文件 base64
      showDetailedDialog: false,
      expandIndex: -1, // 当前选择行
      openBottomSheet: false,
      bigImg: null,
      otherTaskTo: false,
      info: {},
      form: {
        vin: '',
        orderNumber: '',
        checkbox: [],
        text: ''
      },
      options: ['正常', '异常'],
      sort: {
        name: '',
        order: 'asc'
      },
      requestOnce: true,
      columns: [
        { title: '保养项', width: 150, name: 'name' },
        { title: '状态', name: 'calories', width: 120, align: 'left'},
        { title: '保养值', name: 'fat', width: 200, align: 'left'}
      ],
      moveLocation: '',
      list: [
        {
          name: '检查电池电压',
          editType: 1,
          flagxxxx: '',
          lv: '',
          hv: '',
          leftBefore: '',
          rightBefore: '',
          leftAfter: '',
          rightAfter: '',
          remarks: ''
        },
        {
          name: '检查胎压',
          editType: 2,
          flagxxxx: '',
          lv: '',
          hv: '',
          leftBefore: '',
          rightBefore: '',
          leftAfter: '',
          rightAfter: '',
          remarks: ''
        },
        {
          name: '检查车身',
          editType: 3,
          flagxxxx: '',
          lv: '',
          hv: '',
          leftBefore: '',
          rightBefore: '',
          leftAfter: '',
          rightAfter: '',
          remarks: ''
        }
      ],
      valueRow: {},
      valueKey: '',
      valueIndex: -1
    }
  },
  methods: {
    cancelValue () {
      this.selector = false
    },
    sureValue () {
      this.valueRow[this.valueKey] = this.val[0]
      this.selector = false
    },
    selectValueChange (value, index) {
      this.val = ['' + value, '0']
      this.valueRow[this.valueKey] = value
    },
    openSelector (type, row, key) {
      this.selector = true
      this.valueRow = row
      this.valueKey = key
      if (type == 'lv') {
        this.slots = this.lvSlots
        this.val = this.lv
      } else if (type == 'hv') {
        this.slots = this.hvSlots
        this.val = this.hv
      }
      row[key] && (this.val = [row[key] + '', '0'])
    },
    goBackTask () {
      let data = Object.assign({}, this.$store.state.user, {
        content: {
          vin: this.form.vin,
          info: this.info,
          type: this.moveLocation
        }
      })
      /* 发送post请求 */
      if (this.requestOnce) {
        this.common.reqData(api.app('chargeMaintenanceCancel'), data, res => {
          this.requestOnce = true
          this.Toast.clear()
          console.log('返回数据：', res.data)
          if (res.data.status == 100) {
            this.Toast({
              duration: 2000,
              mask: true,
              message: '回退成功'
            })
            this.is_MENU_CDQR = res.data.content.MENU_CDQR// 充电确认
            this.is_MENU_CDWC = res.data.content.MENU_CDWC// 充电完成
            this.is_MENU_YZCDQ = res.data.content.MENU_YZCDQ// 移至充电区
            this.is_MENU_YZCFQ = res.data.content.MENU_YZCFQ// 移至存放区
            this.isShowCard = this.isShowCdq = this.isShowCdqr = this.isShowCfq = this.isShowCdwc = false
            this.isShowDcd = this.isShowCdz = this.isNullTask = true
          } else {
            this.Toast({
              duration: 2000,
              mask: true,
              message: res.data.msg
            })
          }
        }, err => {
          this.requestOnce = true
          this.Toast.clear()
          // 提示
          this.Toast({
            mask: true,
            message: '请求超时，检查你的网络或稍后再试'
          })
          console.log(err)
        })
      }
    },
    openSheet (type) {
      this.moveLocation = type
      this.openBottomSheet = true
    },
    selectAreas (e) {
      this.selectArea = e
      this.openBottomSheet = false
      this.Toast.loading({message: '加载中'})
      let data = Object.assign({}, this.$store.state.user, {
        content: {
          selectArea: e,
          vin: this.form.vin,
          info: this.info,
          type: this.moveLocation
        }
      })
      /* 发送post请求 */
      if (this.requestOnce) {
        this.common.reqData(api.app('moveCharge'), data, res => {
          this.requestOnce = true
          this.Toast.clear()
          console.log('返回数据：', res.data)
          if (res.data.status == 100) {
            this.Toast({
              duration: 2000,
              mask: true,
              message: '提交成功'
            })
            // 跳转
            this.$router.push({ path: '/transposing', query: {whereFrom: 'chargeMaintenance'}})
          } else {
            this.Toast({
              duration: 2000,
              mask: true,
              message: res.data.msg
            })
          }
        }, err => {
          this.requestOnce = true
          this.Toast.clear()
          // 提示
          this.Toast({
            mask: true,
            message: '请求超时，检查你的网络或稍后再试'
          })
          console.log(err)
        })
      }
    },
    changeAbnormal (val, index) {
      val === '异常' ? this.expandIndex = index : this.expandIndex = -1
    },
    rowClick (index, row, event) {
      row.flagxxxx === '异常' ? this.expandIndex = index : this.expandIndex = -1
    },
    handleSortChange ({name, order}) {
      this.list = this.list.sort((a, b) => order === 'asc' ? a[name] - b[name] : b[name] - a[name])
    },
    hideDetailed () {
      this.showDetailedDialog = false
    },
    showDetailed () {
      this.showDetailedDialog = true
    },
    openFullscreenDialog (index) {
      this.bigImg = this.src[index]
      this.openFullscreen = true
    },
    closeFullscreenDialog () {
      this.openFullscreen = false
    },
    handleSortChange ({name, order}) {
      this.list = this.list.sort((a, b) => order === 'asc' ? a[name] - b[name] : b[name] - a[name])
    },
    changeCheckBox (v) {
      console.log(this.form.checkbox)
    },
    deleteImgDialog (index) {
      // 删除图片 打开
      this.deleteIndex = index
      this.openAlert = true
    },
    closeAlertDialog (state) {
      // 删除图片 关闭
      if (state === 'y') {
        this.src.splice(this.deleteIndex, 1)
        this.files.splice(this.deleteIndex, 1)
      }
      this.openAlert = false
    },

    paizhao () {
      let _this = this
      if (window.plus) {
        var cmr = plus.camera.getCamera()
        var res = cmr.supportedImageResolutions[0]
        var fmt = cmr.supportedImageFormats[0]
        console.log('Resolution: ' + res + ', Format: ' + fmt)
        cmr.captureImage(function (path) {
          plus.io.resolveLocalFileSystemURL(path, function (entry) {
            // 转化本地绝对路径
            var url = plus.io.convertLocalFileSystemURL(path)
            _this.src.push('file://' + url)
            // 获取图片对象
            entry.file(function (file) {
              var fileReader = new plus.io.FileReader()
              fileReader.onloadend = function (evt) {
                console.log(evt.target.result)
                _this.files.push(evt.target.result)
              }
              fileReader.readAsDataURL(file)
            })
          })
        },
        function (error) {
          console.log('拍照已经取消: ' + error.message)
        },
        {resolution: res, format: fmt}
        )
      }
    },

    saveCharge (type) {
      this.Toast.loading({message: '加载中'})
      let data = Object.assign({}, this.$store.state.user, {
        content: {
          selectArea: this.selectArea,
          vin: this.form.vin,
          info: this.info,
          type: type
        }
      })
      if (type === 'done' && (!this.info.afterLowPower || !this.info.afterHighPower)) {
        this.Toast({
          duration: 2000,
          mask: true,
          message: '未填写充电完电压'
        })
        return false
      }
      /* 发送post请求 */
      if (this.requestOnce) {
        this.common.reqData(api.app('saveCharge'), data, res => {
          this.requestOnce = true
          this.Toast.clear()
          console.log('返回数据：', res.data)
          if (res.data.status === 100) {
            this.Toast({
              duration: 2000,
              mask: true,
              message: '提交成功'
            })
            if (type === 'done') {
              console.log(this.info)
              return
            }
            this.is_MENU_CDQR = false// 充电确认
            this.is_MENU_CDWC = false// 充电完成
            this.is_MENU_YZCDQ = false// 移至充电区
            this.is_MENU_YZCFQ = false// 移至存放区
            this.isShowCard = false
            this.isNullTask = this.isShowDcd = this.isShowCdz = true
            // this.info = res.data.content.task || {};
            this.isShowCdq = this.isShowCdqr = false
            this.isShowCfq = this.isShowCdwc = false
          } else {
            this.Toast({
              duration: 2000,
              mask: true,
              message: res.data.msg
            })
          }
        }, err => {
          this.requestOnce = true
          this.Toast.clear()
          // 提示
          this.Toast({
            mask: true,
            message: '请求超时，检查你的网络或稍后再试'
          })
          console.log(err)
        })
      }
    },

    receive (type) {
      this.Toast.loading({message: '领取中'})
      let data = Object.assign({}, this.$store.state.user, {
        content: {
          vin: this.form.vin,
          type: type
        }
      })
      /* 发送post请求 */
      if (this.requestOnce) {
        this.common.reqData(api.app('maintenanceGetChargeTask'), data, res => {
          this.requestOnce = true
          this.Toast.clear()
          console.log('返回数据：', res.data)
          if (res.data.status === 100) {
            this.Toast({
              duration: 2000,
              mask: true,
              message: '领取成功'
            })
            this.is_MENU_CDQR = res.data.content.MENU_CDQR// 充电确认
            this.is_MENU_CDWC = res.data.content.MENU_CDWC// 充电完成
            this.is_MENU_YZCDQ = res.data.content.MENU_YZCDQ// 移至充电区
            this.is_MENU_YZCFQ = res.data.content.MENU_YZCFQ// 移至存放区
            this.isShowCard = true
            this.isNullTask = this.isShowDcd = this.isShowCdz = false
            this.info = res.data.content.task || {}
            if (type === 'wait') {
              this.isShowCdq = this.isShowCdqr = true
            }
            if (type === 'working') {
              this.isShowCfq = this.isShowCdwc = true
            }
          } else {
            this.Toast({
              duration: 2000,
              mask: true,
              message: res.data.msg
            })
          }
        }, err => {
          this.requestOnce = true
          this.Toast.clear()
          // 提示
          this.Toast({
            mask: true,
            message: '请求超时，检查你的网络或稍后再试'
          })
          console.log(err)
        })
      }
    },

    getData () {
      console.log(this.form)
      this.Toast.loading({message: '查询中'})
      let data = Object.assign({}, this.$store.state.user, {
        content: {
          vin: this.form.vin
        }
      })
      /* 发送post请求 */
      if (this.requestOnce) {
        this.requestOnce = false
        this.common.reqData(api.app('maintenanceGetCharge'), data, res => {
          this.requestOnce = true
          this.Toast.clear()
          console.log('返回数据：', res.data)
          if (res.data.status === 100) {
            // this.Toast({
            //   duration: 2000,
            //   mask: true,
            //   message: '提交成功'
            // });
            this.isShowCard = true
            this.isNullTask = this.isShowDcd = this.isShowCdz = false
            this.info = res.data.content.task[0] || {}
            this.form.vin = this.info.vin
            this.is_MENU_CDQR = res.data.content.MENU_CDQR// 充电确认
            this.is_MENU_CDWC = res.data.content.MENU_CDWC// 充电完成
            this.is_MENU_YZCDQ = res.data.content.MENU_YZCDQ// 移至充电区
            this.is_MENU_YZCFQ = res.data.content.MENU_YZCFQ// 移至存放区
            if (this.info.status === '待充电') {
              this.isShowCdq = this.isShowCdqr = true
            }
            if (this.info.status === '充电中') {
              this.isShowCfq = this.isShowCdwc = true
            }
          } else {
            this.Toast({
              duration: 2000,
              mask: true,
              message: res.data.msg
            })
          }
        }, err => {
          this.requestOnce = true
          this.Toast.clear()
          // 提示
          this.Toast({
            mask: true,
            message: '请求超时，检查你的网络或稍后再试'
          })
          console.log(err)
        })
      }
    },

    getTargetLocation () {
      this.Toast.loading({message: '查询中'})
      let data = Object.assign({}, this.$store.state.user, {
        content: {
        }
      })
      /* 发送post请求 */
      this.common.reqData(api.app('maintenanceGetChargeArea'), data, res => {
        this.Toast.clear()
        console.log('库区返回数据：', res.data)
        if (res.data.status === 100) {
          // this.Toast({
          //   duration: 2000,
          //   mask: true,
          //   message: '提交成功'
          // });
          console.log('area================' + JSON.stringify(res.data.content.area))
          this.area = res.data.content.area || []
        } else {
          this.Toast({
            duration: 2000,
            mask: true,
            message: res.data.msg
          })
        }
      }, err => {
        this.Toast.clear()
        // 提示
        this.Toast({
          mask: true,
          message: '请求超时，检查你的网络或稍后再试'
        })
        console.log(err)
      })
    },
    closeing (val) {
      val ? this.isScanning = false : null
    },
    childByValue (val) {
      if (val) {
        if (val.split('&')[1] == 'vin') {
          this.form.vin = val.split('&')[0]
          this.getData()
        }
      }
    },
    scan (txt) {
      this.scanMark = txt
      this.isScanning = true
    },
    closeFullscreenDialog () {
      this.openFullscreen = false
      this.closeScan()
    },
    scanQR () {
      this.openFullscreen = true
      let _this = this
      if (!window.plus) { return }
      setTimeout(() => {
        scan = new plus.barcode.Barcode('bcid')
        scan.onmarked = onmarked
        function onmarked (type, result, file) {
          switch (type) {
            case plus.barcode.QR:
              type = 'QR'
              break
            case plus.barcode.EAN13:
              type = 'EAN13'
              break
            case plus.barcode.EAN8:
              type = 'EAN8'
              break
            default:
              type = '其它' + type
              break
          }
          result = result.replace(/\n/g, '')
          _this.form.vin = result
          _this.closeScan()
        }
      }, 40)
    },
    // 开始扫描
    startScan () {
      if (!window.plus) { return }
      scan.start()
    },
    // 关闭
    closeScan () {
      this.openFullscreen = false
      if (!window.plus) { return }
      scan.close()
    }
  },
  mounted () {
    this.getData() // 查询任务

    this.getTargetLocation() // 获取库区
  },
  watch: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.auto-width{
  width: 95%;
  max-width: 375px;
  margin: 10px auto;
}
.my-null{
  color: red;
  font-size: 1.25rem;
  font-weight: bold;
  padding: 15px;
  margin-bottom: 2rem;
}
.detailed{
  padding: 15px;
  height: calc(100% - 56px);
  box-sizing: border-box;
  overflow-x: hidden;
  overflow-y: auto;
}
.my-card{
  margin-bottom: 2rem;
  padding: 15px;
}
.input{
  display: block;
  margin-top: 15px;
  margin-bottom: 15px;
}
#mytable .mu-input{
  width: 100%;
  margin: 0;
}
.chargeMaintenance-btns{
  display: flex;
  width: 85%;
  margin-top: 20px;
  justify-content: space-between;
}
.chargeMaintenance-btns button{
  margin: 0 0;
}
.photos{
    border: 1px solid #ccc;
    width: 90%;
    margin: 20px auto 0;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
}
i.iconfont.icon-icon25201{
    display: block;
    font-size: 50px;
    margin: 10px;
}
.chargeMaintenance-box{
  padding-bottom: 50px;
}
.bottom-sheet-mine{
  display: flex;
  justify-content: space-around;
}
.bottom-sheet-mine > div{
  line-height: 2rem;
  background: #eee;
  padding: 0 20px;
  border-radius: 10px;
  margin: 1rem 0;
}
</style>



// WEBPACK FOOTER //
// src/components/maintenance/chargeMaintenance.vue